import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "cssBorderRadius"];
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { filterProps } from 'foundations-components/utils/filterProps';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "PPUIGrid__StyledDiv"
})(({
  $cssStyles
}) => {
  return Object.assign({
    display: 'grid'
  }, $cssStyles);
});
const gridStylePropKeys = {
  display: true,
  gridRow: true,
  gridRowStart: true,
  gridRowEnd: true,
  gridColumn: true,
  gridColumnStart: true,
  gridColumnEnd: true,
  placeContent: true,
  placeItems: true
};
function filterGridProps(props) {
  const gridProps = {};
  const rest = {};
  Object.keys(props).forEach(key => {
    if (key in gridStylePropKeys) {
      gridProps[key] = props[key];
    } else {
      rest[key] = props[key];
    }
  });

  // Trellis filterProps only supports tokenized props, which does NOT include grid style props
  const {
    domProps,
    tokenProps,
    callbackProps
  } = filterProps(rest);
  return {
    gridProps,
    domProps,
    tokenProps,
    callbackProps
  };
}
export const PPUIGrid = _ref => {
  let {
      children,
      cssBorderRadius
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    gridProps,
    domProps,
    tokenProps,
    callbackProps
  } = filterGridProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledDiv, Object.assign({}, domProps, callbackProps, {
    $cssStyles: Object.assign({}, cssStyles, gridProps, cssBorderRadius !== undefined && {
      borderRadius: cssBorderRadius
    }),
    children: children
  }));
};